var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophoneOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.36603,
    y1: 3.36603,
    x2: 16.866,
    y2: 19.8205,
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5175 14.9489C17.4406 13.8937 18 12.5122 18 11V8C18 7.44772 17.5523 7 17 7C16.4477 7 16 7.44772 16 8V11C16 11.7544 15.7912 12.46 15.4282 13.0621L16.5175 14.9489ZM8 8.19615V11C8 13.185 9.75199 14.9609 11.9278 14.9994L13.0319 16.9116C13.0213 16.9134 13.0106 16.9153 13 16.917V19H14C14.0888 19 14.1749 19.0116 14.2568 19.0333L14.9656 20.2609C14.8508 20.6867 14.462 21 14 21H10C9.44772 21 9 20.5523 9 20C9 19.4477 9.44772 19 10 19H11V16.917C8.16229 16.441 6 13.973 6 11V8C6 7.44772 6.44772 7 7 7C7.1211 7 7.23717 7.02153 7.3446 7.06096L8 8.19615ZM14 10.5885L10.2326 4.06309C10.5685 3.43067 11.234 3 12 3C13.1046 3 14 3.89543 14 5V10.5885Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphoneOff.5f1a435b883a260c3df9cf5022cfd3df.svg";
export { ForwardRef as ReactComponent };